import React, {useContext, useEffect, useState} from 'react';
import {Input, Popconfirm, Popover} from 'antd';
import axios from "../../common/axios";
import dayjs from "dayjs";
import {
    BookRounded, DeleteRounded,
    DynamicFormOutlined, InfoRounded, MenuBookRounded,
    PasswordRounded,
    PersonRemoveRounded
} from "@mui/icons-material";
import Tooltip from "../../common/Tooltip";
import TableAntD from "../../common/TableAntD";
import StudentQuickReportDialog from "./StudentQuickReportDialog";
import RemoveUserFromClassButton from "./RemoveUserFromClassButton";
import Button from "../../common/Button";
import StudentResourcesDialog from "./StudentResourcesDialog";
import {UserContext} from "../../common/UserContext";

const { Search } = Input;

const ClassDetailsProgressSummary = ({ classId, className, classStudents }) => {
    const [searchText, setSearchText] = useState('');
    const [reportData, setReportData] = useState([]);
    const [dateRange, setDateRange] = useState(() => [dayjs().subtract(6, 'day'), dayjs()]);
    const [isStudentResourcesDialogOpen, setIsStudentResourcesDialogOpen] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState();
    const { user } = useContext(UserContext);

    const loadReportData = () => {
        const [start, end] = dateRange || [];

        const isUSLocale = user.locale === 'en_US';

        let formattedStart, formattedEnd;

        if (start) {
            const day = start.date().toString().padStart(2, '0');
            const month = (start.month() + 1).toString().padStart(2, '0');
            const year = start.year();
            formattedStart = isUSLocale ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
        }

        if (end) {
            const day = end.date().toString().padStart(2, '0');
            const month = (end.month() + 1).toString().padStart(2, '0');
            const year = end.year();
            formattedEnd = isUSLocale ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
        }

        axios.get('/web/ui/report/teacher/activity/classReport', {
            params: {
                classId: classId,
                ...(formattedStart && { startSearch: formattedStart }),
                ...(formattedEnd && { endSearch: formattedEnd }),
                ...((formattedStart && formattedEnd) && { searchPeriod: 'DATE_RANGE' })
            }
        })
            .then(response => {
                if (response.data) {
                    setReportData(response.data?.reportData);
                } else {
                    console.error('Failed to load report: No data received');
                }
            })
            .catch(error => {
                console.error('Error fetching report:', error);
            })
            .finally(() => {
                // setLoading(false)
            });
    };

    const tableData = reportData
        .map((item, index) => {
            const { name, countSessions, lastLogin, countExercises, countQuestions, countWalkthroughs, countQuizzes, countTests, countScorchers, studentId } = item;

            return {
                key: index,
                student: name,
                // lastLogin: generateReadableLastLogin(lastLogin),
                activitiesComplete: countTests + countQuizzes + countWalkthroughs  + countScorchers + countExercises,
                sessionsThisWeek: countSessions,
                quizQuestions: countQuestions,
                walkthroughsComplete: countWalkthroughs,
                testsComplete: countTests,
                scorchersComplete: countScorchers,
                studentId: studentId,
                rawLastLogin: lastLogin,
                rawActivityCounts: [countSessions, countQuestions, countTests, countQuizzes, countWalkthroughs, countScorchers, countExercises],
            };
        })

    useEffect(() => {
        if(classId){
            loadReportData();
        }
    }, [classId]);

    const filteredData = tableData.filter((student) =>
        student.student.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleRemoveUserSuccess = (userId) => {
        loadReportData();
    };

    const handleQuickReportButtonClick = (record) => {
        setSelectedStudent(record);
        setIsQuickReportDialogOpen(true);
    }

    const handleSubscriptionsButtonClick = (record) => {
        setSelectedStudent(record);
        setIsStudentResourcesDialogOpen(true);
    }

    const columns = [
        {
            title: 'Student',
            dataIndex: 'student',
            key: 'student',
            render: (text, record) => (<strong>{text}</strong>)
        },
        {
            title: 'Sessions this week',
            dataIndex: 'sessionsThisWeek',
            key: 'sessionsThisWeek',
        },
        {
            title: 'Activities this week',
            dataIndex: 'activitiesComplete',
            key: 'activitiesComplete',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (value, record) => {
                return (
                    <div className={'ch-table-controls'}>
                        <Tooltip title={'User Subscriptions'}>
                            <Button
                                type={'text'}
                                onClick={() => handleSubscriptionsButtonClick(record)}
                            >
                                <MenuBookRounded />
                            </Button>
                        </Tooltip>
                        <RemoveUserFromClassButton
                            userId={record.studentId}
                            classId={classId}
                            userName={record.student}
                            className={className}
                            onSuccess={handleRemoveUserSuccess}
                        />
                    </div>
                )
            }
        }
    ];

    return (
        <div>
            <Search
                placeholder="Search by student name"
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: 300, marginBottom: 16 }}
                allowClear
            />
            <TableAntD
                dataSource={filteredData}
                columns={columns}
                pagination={{ pageSize: 10 }}
            />
            <StudentResourcesDialog
                visible={isStudentResourcesDialogOpen}
                onClose={() => setIsStudentResourcesDialogOpen(false)}
                selectedStudent={selectedStudent}
                classStudents={classStudents}
            />
        </div>
    );
};

export default ClassDetailsProgressSummary;